import { React, Suspense, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Float } from "@react-three/drei";
import { proxy } from "valtio";
import Shoe from "./Components/Shoe";
import Loader from "./Components/Loader";
import ColorPicker from "./Components/ColorPicker";

const ShoeState = proxy({
  current: null,
  colors: {
    laces: "#d3d3d3",
    mesh: "#d3d3d3",
    caps: "#d3d3d3",
    inner: "#d3d3d3",
    sole: "#d3d3d3",
    stripes: "#d3d3d3",
    band: "#d3d3d3",
    patch: "#d3d3d3",
  },
});

function App() {
  const controls = useRef();

  const updateShoeCurrent = (value) => {
    ShoeState.current = value;
  };

  const updateShoeColor = (pro, value) => {
    ShoeState.colors[pro] = value;
  };

  return (
    <>
      <header className="app-header">
        <h1>Make Your Own Shoe</h1>
        <p>Customize every detail of your perfect shoe</p>
      </header>

      <ColorPicker state={ShoeState} updateColor={updateShoeColor} />

      <Canvas shadows camera={{ position: [1, 0, 2] }}>
        <ambientLight />
        <spotLight
          intensity={0.5}
          penumbra={1}
          position={[7, 15, 10]}
          castShadow
        />
        <mesh
          receiveShadow
          rotation={[-Math.PI / 2, 0, 1.1]}
          position={[0, -1, 0]}
        >
          <planeGeometry args={[100, 100]} />
          <shadowMaterial opacity={0.3} />
        </mesh>
        <Suspense fallback={<Loader />}>
          <Float
            speed={1}
            rotationIntensity={1}
            floatIntensity={1}
            floatingRange={[0, 0.3]}
          >
            <Shoe
              castShadow
              colors={ShoeState.colors}
              updateCurrent={updateShoeCurrent}
            />
          </Float>
        </Suspense>
        <OrbitControls ref={controls} maxDistance={5} minDistance={1.5} />
      </Canvas>

      <footer className="app-footer">
        <p>© IshaanMinocha</p>
      </footer>
    </>
  );
}

export default App;
